/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:36:50
 * @LastEditTime: 2023-02-20 15:54:56
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\behavior-statistics-report\modules\retailAnalyseRouter.js
 * 零售分析
 */
const retailAnalyseRouter = [
  // 月度KPI分析
  {
    path: '/behaviorManage/Monthly-KPI-analysis/index',
    name: 'MonthlyKPIanalysisIndex',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManage-Monthly-KPI-analysis-index" */
        '@/views/behavior-manage/behavior-statistics-report/retail-analyse/monthy-kpi/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '零售分析', //二级菜单
      title: '月度KPI分析'
    }
  },
  // 月度KPI分析 分销率明细
  /*
   * 部门 时间、产品
   * */
  {
    path: '/behaviorManage/Monthly-KPI-analysis/departmentSalesRateDetail/:department_id/:year/:month/:goods_id',
    name: 'MonthlyKPIanalysisDepartmentSalesRateDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"DirectQuarter" */
      //   '@/views/behaviorManage/Monthly-KPI-analysis/departmentSalesRateDetail'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"DirectQuarter" */
        '@/views/behavior-manage/behavior-statistics-report/retail-analyse/monthy-kpi/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '零售分析', //二级菜单
      title: '分销率明细',
      breadcrumb: [
        {
          title: '月度KPI分析',
          name: 'MonthlyKPIanalysisIndex'
        }
      ]
    }
  },
  // 月度KPI分析 部门平均陈列面明细
  /*
   * 部门 时间、产品
   * */
  {
    path: '/behaviorManage/Monthly-KPI-analysis/departmentDisplayDetail/:department_id/:year/:month/:goods_id',
    name: 'MonthlyKPIanalysisDepartmentDisplayDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"DirectQuarter" */
      //   '@/views/behaviorManage/Monthly-KPI-analysis/departmentDisplayDetail'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"DirectQuarter" */
        '@/views/behavior-manage/behavior-statistics-report/retail-analyse/display-surface/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '零售分析', //二级菜单
      title: '陈列面明细',
      breadcrumb: [
        {
          title: '月度KPI分析',
          name: 'MonthlyKPIanalysisIndex'
        }
      ]
    }
  },

  // 标准陈列面设置列表
  {
    path: '/behaviorManage/Monthly-KPI-analysis/displayList',
    name: 'MonthlyKPIanalysisDisplayList',
    component: () =>
      // import(
      //   /*webpackChunkName:"DirectQuarter" */
      //   '@/views/behaviorManage/Monthly-KPI-analysis/displayList'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"DirectQuarter" */
        '@/views/behavior-manage/behavior-statistics-report/retail-analyse/display-surface/Edit.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '零售分析', //二级菜单
      title: '标准陈列面设置',
      breadcrumb: [
        {
          title: '月度KPI分析',
          name: 'MonthlyKPIanalysisIndex'
        }
      ]
    }
  },
  // 部门陈列位置明细
  /*
   * 部门 时间、产品
   * */
  {
    path: '/behaviorManage/Monthly-KPI-analysis/departmentGoodsLocationDetail/:department_id/:year/:month/:goods_id',
    name: 'MonthlyKPIanalysisDepartmentGoodsLocationDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"DirectQuarter" */
      //   '@/views/behaviorManage/Monthly-KPI-analysis/departmentGoodsLocationDetail'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"DirectQuarter" */
        '@/views/behavior-manage/behavior-statistics-report/retail-analyse/DisplayLocationDetail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '零售分析', //二级菜单
      title: '陈列位置（好位置）明细',
      breadcrumb: [
        {
          title: '月度KPI分析',
          name: 'MonthlyKPIanalysisIndex'
        }
      ]
    }
  },

  // 部门终端库存明细
  /*
   * 部门 时间、产品
   * */
  {
    path: '/behaviorManage/Monthly-KPI-analysis/departmentClientStockDetail/:department_id/:year/:month/:goods_id',
    name: 'MonthlyKPIanalysisDepartmentClientStockDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"DirectQuarter" */
      //   '@/views/behaviorManage/Monthly-KPI-analysis/departmentClientStockDetail'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"DirectQuarter" */
        '@/views/behavior-manage/behavior-statistics-report/retail-analyse/TerminalInventoryDetail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '零售分析', //二级菜单
      title: '部门终端库存明细',
      breadcrumb: [
        {
          title: '月度KPI分析',
          name: 'MonthlyKPIanalysisIndex'
        }
      ]
    }
  },

  // 部门终端平均价格明细
  /*
   * 部门 时间、产品
   * */
  {
    path: '/behaviorManage/Monthly-KPI-analysis/departmentClientPriceDetail/:department_id/:year/:month/:goods_id',
    name: 'MonthlyKPIanalysisDepartmentClientPriceDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"DirectQuarter" */
      //   '@/views/behaviorManage/Monthly-KPI-analysis/departmentClientPriceDetail'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"DirectQuarter" */
        '@/views/behavior-manage/behavior-statistics-report/retail-analyse/ProductPriceDetail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '零售分析', //二级菜单
      title: '部门终端平均价格明细',
      breadcrumb: [
        {
          title: '月度KPI分析',
          name: 'MonthlyKPIanalysisIndex'
        }
      ]
    }
  }
]
export default retailAnalyseRouter
